<template>
  <el-dialog
    :title="$t('i18n.XxhDpKVqozr0')"
    :visible.sync="dialogVisible"
    append-to-body
    width="800px"
    @closed="handleClosed"
  >
    <el-form v-load.lazy="loading" ref="ElForm" :model="form" :rules="rules" label-width="125px">
      <el-form-item :label="$t('17010')">
        <span>{{ form.ot_date_at }}</span>
      </el-form-item>
      <el-form-item :label="$t('16439')" prop="ot_setting_id">
        <el-select v-model="form.ot_setting_id" @change="calculateOverTime">
          <el-option
            v-for="item in overTimeTypeOptions"
            :key="item.id"
            :label="item.type_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('1101')" prop="ot_start_time">
        <el-date-picker
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          v-model="form.ot_start_time"
          :picker-options="pickerOptions"
          style="width: 250px; max-width: 250px"
          @change="calculateOverTime"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('1102')" prop="ot_end_time">
        <el-date-picker
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          v-model="form.ot_end_time"
          :picker-options="pickerOptions"
          style="width: 250px; max-width: 250px"
          @change="calculateOverTime"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('i18n.UXGpCUoypv3R')" style="margin-bottom: 0">
        <span>{{ form.ot_duration }}</span>
      </el-form-item>
      <el-form-item class="line-height-28">
        <template v-if="messages.length > 0">
          <p v-for="(item, index) in messages" :key="index">{{ item }}</p>
        </template>
      </el-form-item>
      <el-form-item :label="$t('i18n.92Wq25eb96oJ')" prop="ot_audit_reason">
        <el-input v-model="form.ot_audit_reason" :autosize="{ minRows: 3 }" type="textarea" maxlength="500"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="submit" :loading="loading">{{ $t('131') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { createRange } from './rang'

function createFormModel(vm) {
  return {
    // 加班日期
    ot_date_at: '',
    // 加班类型ID
    ot_setting_id: '',
    // 加班开始时间
    ot_start_time: '',
    // 加班结束时间
    ot_end_time: '',
    // 加班时长（自动计算）
    ot_duration: '',
    // 加班备注
    ot_audit_reason: ''
  }
}

function createFormRule(vm) {
  return {
    ot_setting_id: {
      required: true,
      message: vm.$t('i18n.st3AxhXiV26W'),
      trigger: 'change'
    },
    ot_start_time: {
      required: true,
      message: vm.$t('i18n.st3AxhXiV26W'),
      trigger: 'change'
    },
    ot_end_time: {
      required: true,
      message: vm.$t('i18n.st3AxhXiV26W'),
      trigger: 'change'
    },
    ot_audit_reason: {
      required: true,
      message: vm.$t('i18n.st3AxhXiV26W'),
      trigger: 'change'
    }
  }
}

export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      params: '',
      form: createFormModel(this),
      rules: createFormRule(this),
      overTimeTypeOptions: [],
      pickerOptions: {},
      over_time: {},
      messages: []
    }
  },
  methods: {
    init(params) {
      this.params = params
      this.dialogVisible = true
      const { staff_id, attendance_date } = params
      this.form.ot_date_at = attendance_date
      this.pickerOptions = createRange(this.form.ot_date_at)
      this.$http({
        url: '/web/over_time/getOverTimeInit',
        data: {
          staff_id
        }
      }).then(res => {
        this.overTimeTypeOptions = res.data.types
      })
    },
    checkTime() {
      const s = parseInt(this.form.ot_start_time.replace(/-|:|\s/g, ''))
      const e = parseInt(this.form.ot_end_time.replace(/-|:|\s/g, ''))
      if (s >= e) {
        this.$message.warning(this.$t('i18n.741b9e823d8a4340a1e92d774095ccd4'))
        return false
      }
      return true
    },
    calculateOverTime() {
      const { ot_date_at, ot_setting_id, ot_start_time, ot_end_time } = this.form
      if (ot_setting_id && ot_start_time && ot_end_time) {
        const { staff_id } = this.params
        const data = { staff_id, ot_date_at, ot_setting_id, ot_start_time, ot_end_time }
        if (!this.checkTime()) return
        this.$http({
          url: '/web/over_time/calculateOverTime',
          data
        })
          .then(res => {
            this.form.ot_duration = res.data.over_time.over_time_hour
            this.over_time = res.data.over_time || {}
            this.messages = [...(this.over_time.deduction_details || []), ...(this.over_time.alert_details || [])]
          })
          .catch(() => {
            this.form.ot_duration = ''
            this.over_time = {}
            this.messages = []
          })
      } else {
        this.form.ot_duration = ''
        this.over_time = {}
        this.messages = []
      }
    },
    submit() {
      this.$refs.ElForm.validate(valid => {
        if (valid) {
          if (!this.checkTime()) return
          const { staff_id } = this.params
          this.loading = true
          this.$http({
            url: '/web/over_time/add',
            data: {
              staff_id,
              ...this.form,
              ot_duration: this.over_time.over_time_duration
            }
          })
            .then(() => {
              this.dialogVisible = false
              this.$emit('update')
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleClosed() {
      this.$refs.ElForm.resetFields()
      this.form.ot_duration = ''
      this.over_time = {}
      this.messages = []
    }
  }
}
</script>

<style scoped>
.line-height-28 /deep/ .el-form-item__content {
  line-height: 28px;
}
</style>
